
import firebase from 'firebase'
import 'firebase/database'



const firebaseConfig = {
  apiKey: "AIzaSyDAG5xC67A6YhjKXcQ9spurjcRXmH__zNg",
  authDomain: "kbo-fantasy.firebaseapp.com",
  databaseURL: "https://kbo-fantasy.firebaseio.com",
  projectId: "kbo-fantasy",
  storageBucket: "kbo-fantasy.appspot.com",
  messagingSenderId: "19664215470",
  appId: "1:19664215470:web:4638917bd424cf26a6fc3f"
};

export const db = firebase
  .initializeApp(firebaseConfig)
  .database()





// WEBPACK FOOTER //
// ./src/db.js